import { useAuth } from "@/contexts/AuthContext";
import { landingPathFor } from "@/lib/constants/roles";
import { Button } from "@ai-teach/ui-web";
import { useNavigate } from "@tanstack/react-router";

interface AccessDeniedProps {
  description: string;
}

/** Usually hit when a browser still holds another role's session, so signing out is the way out. */
export function AccessDenied({ description }: AccessDeniedProps) {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const landingPath = landingPathFor(user?.role);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="text-center space-y-4">
        <h1 className="h2">Access Denied</h1>
        <p className="body text-secondary-200">{description}</p>
        {user && (
          <p className="body-sm text-gray-500">
            Signed in as {user.name} ({user.email})
          </p>
        )}
        <div className="flex justify-center gap-3 pt-2">
          {landingPath && (
            <Button variant="primary" onClick={() => navigate({ to: landingPath })}>
              Go to Home
            </Button>
          )}
          <Button variant="secondary" onClick={() => signOut()}>
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
}
